import React from 'react';

const YourBooksDrawer = React.createContext();

export const useYourBooksDrawer = () => React.useContext(YourBooksDrawer);

export default function YourBooksDrawerContext(props) {
	return (
		<YourBooksDrawer.Provider value={props.drawer}>
			{typeof props.children === 'function'
				? props.children(props.drawer)
				: props.children}
		</YourBooksDrawer.Provider>
	);
}
